export const characteristicsList = [
  "Debit",
  "Credit Card",
  "Cash",
  "City Ledger",
  "Check",
  "Other Credit",
  "Credit Post",
];

export const postTypesCategoryList = ["Revenue", "Non- Revenue Debits"];
